import React from "react";
import { SignupPage } from "@components/onboarding/signup";
import { useRouter } from "next/router";

const Signup: React.FC = () => {
  const router = useRouter();
  const {
    query: { token = undefined },
  } = router;

  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <SignupPage inviteToken={token ? String(token) : undefined} />
    </div>
  );
};

export default Signup;
